<template>
  <div id="app">
    <my-nav-bar></my-nav-bar>
    <router-view />
  </div>
</template>

<script lang="ts" src="./App.ts">
</script>
